import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ViewWillEnter } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { ChatService } from 'src/app/services/chat.service';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit, ViewWillEnter {

  liveSupportName: string = 'Live Chat';

  constructor(
    public dataServ: DataService,
    public chatServ: ChatService,
    public authServ: AuthService,
    public modalServ: ModalMakerService,
    private titleService: Title,
  ) { }

  ngOnInit() {
    // livesupportname'i dinamik olarak ata
    const actionButtons = this.dataServ.rData?.action_buttons;
    if (actionButtons) {
      const liveSupportBtn = actionButtons.find((x: any) => x.code === 'LiveSupport');
      if (liveSupportBtn) {
        this.liveSupportName = liveSupportBtn.name;
      }
    }
  }

  async ionViewWillEnter() {
    this.authServ.control();
    if (this.authServ.isLogged) {
      await this.chatServ.getHeaders();
      await this.authServ.getMe();
    }

    this.titleService.setTitle('My Messages');
  }
}
